<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="520px"
    custom-class="quick-fill-dialog"
    @close="$emit('update:visible', false)">
    <div class="qf-modal">
      <!-- 顶部警告条 -->
      <div class="qf-top-bar">
        <div class="qf-top-left">
          <i class="el-icon-warning" style="color:#D97706;font-size:18px;flex-shrink:0"></i>
          <span class="qf-top-title">立即补排</span>
        </div>
        <div class="qf-close" @click="$emit('update:visible', false)">
          <i class="el-icon-close" style="color:#94A3B8;font-size:15px"></i>
        </div>
      </div>
      <!-- 元信息条 -->
      <div class="qf-meta-bar">
        <span class="qf-meta-tag">
          <i class="el-icon-date" style="margin-right:4px"></i>
          {{ weekLabel }} {{ date }}
        </span>
        <span class="qf-meta-tag">
          <i class="el-icon-time" style="margin-right:4px"></i>
          {{ shiftName }} {{ shiftTime }}
        </span>
        <span class="qf-meta-lock">
          <i class="el-icon-lock" style="margin-right:4px"></i>
          日期班次已锁定
        </span>
      </div>

      <!-- 表单 -->
      <div class="qf-body">
        <!-- 指定护工 -->
        <div class="qf-field">
          <div class="qf-label">指定护工 <span class="req">*</span></div>
          <el-select
            v-model="form.staffIds"
            placeholder="搜索或选择护工（可多选）"
            multiple
            filterable
            style="width:100%"
            @visible-change="onStaffDropdown">
            <el-option
              v-for="s in staffList"
              :key="s.userId"
              :value="s.userId"
              :label="s.realName || s.userName">
            </el-option>
          </el-select>
          <div v-if="form.staffIds.length" class="qf-staff-preview">
            <span style="color:#64748B;font-size:12px">当前选择：</span>
            <span v-for="id in form.staffIds" :key="id" class="qf-staff-tag">
              <span class="qf-staff-dot" :style="{ background: staffColor(id) }"></span>
              {{ getStaffName(id) }}
            </span>
          </div>
        </div>

        <!-- 负责房间 -->
        <div class="qf-field">
          <div class="qf-label">负责房间 <span class="req">*</span></div>
          <div class="qf-room-btns">
            <el-button size="mini" @click="selectAllRooms">全部房间</el-button>
            <el-button
              v-for="group in roomBuildingFloors"
              :key="group.key"
              size="mini"
              @click="selectBuildingFloor(group)">
              {{ group.label }}
            </el-button>
            <el-button size="mini" @click="roomPickerVisible = true">自定义</el-button>
          </div>
          <div class="qf-room-preview">
            <i class="el-icon-house" style="color:#94A3B8;font-size:13px;flex-shrink:0"></i>
            <span v-if="!form.roomIds.length" style="color:#94A3B8;font-size:13px">
              点击上方快捷按钮或自定义选择房间
            </span>
            <template v-else>
              <span v-for="id in form.roomIds" :key="id" class="qf-room-tag">
                {{ getRoomNo(id) }}
                <i class="el-icon-close" style="font-size:9px;cursor:pointer" @click="removeRoom(id)"></i>
              </span>
            </template>
          </div>
        </div>
      </div>

      <!-- 底部 -->
      <div class="qf-footer">
        <el-button @click="$emit('update:visible', false)">取消</el-button>
        <el-button
          style="background:#F59E0B;border-color:#F59E0B;color:#fff"
          @click="handleSubmit">
          <i class="el-icon-lightning"></i> 立即补排
        </el-button>
      </div>
    </div>

    <!-- 房间选择器 -->
    <room-picker
      :visible="roomPickerVisible"
      :rooms="rooms"
      :selected="form.roomIds"
      @update:visible="roomPickerVisible = $event"
      @confirm="onRoomPickerConfirm">
    </room-picker>
  </el-dialog>
</template>

<script>
import RoomPicker from './RoomPicker.vue'
import { buildRoomBuildingFloors } from '../scheduleUtils'

const COLORS = ['#2563EB', '#10B981', '#7C3AED', '#F59E0B', '#EF4444', '#06B6D4']

export default {
  name: 'QuickFillModal',
  components: { RoomPicker },
  props: {
    visible: { type: Boolean, default: false },
    date: { type: String, default: '' },
    shiftId: { default: null },
    shiftName: { type: String, default: '' },
    shiftColor: { type: String, default: '' },
    staffList: { type: Array, default: () => [] },
    rooms: { type: Array, default: () => [] },
    shiftList: { type: Array, default: () => [] }
  },
  data() {
    return {
      form: { staffIds: [], roomIds: [] },
      roomPickerVisible: false
    }
  },
  computed: {
    weekLabel() {
      if (!this.date) return ''
      const labels = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      return labels[new Date(this.date).getDay()]
    },
    shiftTime() {
      const s = this.shiftList.find(x => String(x.id) === String(this.shiftId))
      return s ? s.time : ''
    },
    roomBuildingFloors() {
      return buildRoomBuildingFloors(this.rooms)
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.form.staffIds = []
        this.form.roomIds = []
      }
    }
  },
  methods: {
    staffColor(staffId) {
      let hash = 0
      for (const c of String(staffId)) hash = (hash * 31 + c.charCodeAt(0)) & 0xffff
      return COLORS[hash % COLORS.length]
    },
    getStaffName(id) {
      const s = this.staffList.find(s => s.userId === id)
      return s ? (s.realName || s.userName) : ''
    },
    getRoomNo(id) {
      const r = this.rooms.find(r => r.roomId === id)
      return r ? r.roomNo : id
    },
    removeRoom(id) {
      const idx = this.form.roomIds.indexOf(id)
      if (idx >= 0) this.form.roomIds.splice(idx, 1)
    },
    selectAllRooms() {
      this.form.roomIds = this.rooms.map(r => r.roomId)
    },
    selectBuildingFloor(group) {
      const ids = this.rooms
        .filter(r => (r.buildingId != null ? r.buildingId : 0) === group.buildingId && r.floorNo === group.floorNo)
        .map(r => r.roomId)
      ids.forEach(id => {
        if (!this.form.roomIds.includes(id)) this.form.roomIds.push(id)
      })
    },
    onRoomPickerConfirm(rooms) {
      this.form.roomIds = rooms.map(r => r.roomId)
    },
    onStaffDropdown(visible) {
      if (visible) this.$emit('staffSearch', '')
    },
    handleSubmit() {
      if (!this.form.staffIds.length) {
        this.$message.warning('请选择护工')
        return
      }
      const roomList = this.form.roomIds.map(id => {
        const r = this.rooms.find(x => x.roomId === id)
        return { roomId: id, roomNo: r ? r.roomNo : String(id) }
      })
      this.form.staffIds.forEach(staffId => {
        this.$emit('submit', {
          staffId,
          staffName: this.getStaffName(staffId),
          shiftId: this.shiftId,
          shiftName: this.shiftName,
          shiftColor: this.shiftColor,
          date: this.date,
          roomIds: this.form.roomIds,
          roomList,
          status: 1
        })
      })
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.qf-modal { display: flex; flex-direction: column; }
.qf-top-bar {
  display: flex; justify-content: space-between; align-items: center;
  padding: 14px 18px 10px; background: #FFFBEB; border-bottom: 2px solid #FDE68A;
}
.qf-top-left { display: flex; align-items: center; }
.qf-top-left > i { margin-right: 8px; }
.qf-top-title { font-size: 16px; font-weight: 700; color: #92400E; }
.qf-close { width: 28px; height: 28px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.qf-close:hover { background: #FEF3C7; }
.qf-meta-bar {
  display: flex; align-items: center; flex-wrap: wrap;
  padding: 8px 18px; background: #FFFBEB; border-bottom: 1px solid #FDE68A;
}
.qf-meta-bar > * { margin-right: 10px; }
.qf-meta-tag {
  display: inline-flex; align-items: center;
  padding: 3px 10px; border-radius: 6px;
  background: #FEF3C7; color: #92400E; font-size: 12px; font-weight: 500;
}
.qf-meta-lock { display: inline-flex; align-items: center; font-size: 12px; color: #94A3B8; }
.qf-body { padding: 18px; display: flex; flex-direction: column; }
.qf-field { margin-bottom: 16px; }
.qf-label { font-size: 14px; font-weight: 600; color: #1E293B; margin-bottom: 8px; }
.req { color: #EF4444; margin-left: 2px; }
.qf-staff-preview { display: flex; align-items: center; flex-wrap: wrap; margin-top: 8px; }
.qf-staff-preview > * { margin-right: 8px; margin-top: 4px; }
.qf-staff-tag {
  display: inline-flex; align-items: center;
  padding: 3px 10px; border-radius: 20px;
  background: #F1F5F9; font-size: 13px; color: #1E293B;
}
.qf-staff-dot { width: 10px; height: 10px; border-radius: 50%; margin-right: 6px; }
.qf-room-btns { display: flex; flex-wrap: wrap; margin-bottom: 8px; }
.qf-room-btns .el-button { margin-right: 6px; margin-bottom: 6px; }
.qf-room-preview {
  display: flex; align-items: center; flex-wrap: wrap;
  min-height: 42px; padding: 8px 10px; border-radius: 8px;
  background: #F9FAFB; border: 1px solid #E2E8F0;
}
.qf-room-preview > * { margin-right: 6px; margin-top: 2px; }
.qf-room-tag {
  display: inline-flex; align-items: center;
  padding: 2px 8px; border-radius: 4px;
  background: #FEF3C7; color: #92400E; font-size: 12px;
}
.qf-room-tag > i { margin-left: 4px; }
.qf-footer {
  display: flex; justify-content: flex-end;
  padding: 12px 18px; border-top: 1px solid #E2E8F0;
}
.qf-footer .el-button { margin-left: 10px; }
</style>

<style>
.quick-fill-dialog .el-dialog__header { display: none; }
.quick-fill-dialog .el-dialog__body { padding: 0; }
</style>
